import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import { createButtonNew } from 'src/shared/entities/button/create-button'
import { createField } from 'src/shared/entities/field/create-field'
import { createHeadline } from 'src/shared/entities/headline/create-headline'
import { createMenu } from 'src/shared/entities/menu/create-menu'
import { createPopup } from 'src/shared/entities/popup/create-popup'
import { createText } from 'src/shared/entities/text/create-text'
import { createForm } from './form/create-form'

// NOTE: This class is used for extending the common library elements creators in the specific library elements creators
// DON'T USE THIS CLASS DIRECTLY, use the specific library elements creators instead
// (e.g. WebsiteLibraryElementsCreator, PageLibraryElementsCreator)
export class CommonLibraryElementsCreator {
  public [LibraryElementEnum.LibraryButton](
    ...args: Parameters<typeof createButtonNew>
  ) {
    return createButtonNew(...args)
  }
  public [LibraryElementEnum.LibraryField](
    ...args: Parameters<typeof createField>
  ) {
    return createField(...args)
  }
  public [LibraryElementEnum.LibraryMenu](
    ...args: Parameters<typeof createMenu>
  ) {
    return createMenu(...args)
  }
  public [LibraryElementEnum.LibraryHeadline](
    ...args: Parameters<typeof createHeadline>
  ) {
    return createHeadline(...args)
  }
  public [LibraryElementEnum.LibraryText](
    ...args: Parameters<typeof createText>
  ) {
    return createText(...args)
  }
  public [LibraryElementEnum.LibraryPopup](
    ...args: Parameters<typeof createPopup>
  ) {
    return createPopup(...args)
  }
  public [LibraryElementEnum.LibraryForm](
    ...args: Parameters<typeof createForm>
  ) {
    return createForm(...args)
  }
}
